import { Card, useTheme } from '@mui/material'
import { IconButtonWithTooltip } from '@src/components'
import { memo, ReactElement } from 'react'

export interface SideBarRailItem {
  key: string
  tooltip: string
  icon: ReactElement
  href?: string
  target?: string
  onClick?: () => void
}

interface Props {
  items: SideBarRailItem[]
}

const CreditApplicationSideBarRail = ({ items }: Props) => {
  const theme = useTheme()
  const borderColor = theme.palette.divider

  if (items.length === 0) return null

  return (
    <Card
      style={{
        position: 'fixed',
        left: 0,
        top: '18em',
        zIndex: 999,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderLeft: 'none',
        borderRadius: 2,
        borderColor,
      }}
    >
      {items.map((item) =>
        item.href ? (
          <IconButtonWithTooltip
            key={item.key}
            tooltip={item.tooltip}
            icon={item.icon}
            href={item.href}
            target={item.target}
          />
        ) : (
          <IconButtonWithTooltip key={item.key} tooltip={item.tooltip} icon={item.icon} onClick={item.onClick} />
        ),
      )}
    </Card>
  )
}

export default memo(CreditApplicationSideBarRail)
